 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"404":"404","article":"article","articles":"articles","calendar":"calendar","editPost":"editPost","errorModal":"errorModal","login":"login","loginChange":"loginChange","loginRegistration":"loginRegistration","loginRegistrationSuccess":"loginRegistrationSuccess","loginRestore":"loginRestore","loginSignIn":"loginSignIn","mainPage":"mainPage","profile":"profile","settings":"settings","stat":"stat","userSection":"userSection","addComment":"addComment","baseArticle":"baseArticle","comment":"comment","baseButton":"baseButton","baseNavbar":"baseNavbar","calendarTable":"calendarTable","loginHeader":"loginHeader","captcha":"captcha","inputPassword":"inputPassword","inputEmail":"inputEmail","tags":"tags","addText":"addText","moderationBlock":"moderationBlock","socialBlock":"socialBlock","calendarMonth":"calendarMonth"}[chunkId]||chunkId) + "." + {"404":"47dd94cc","article":"f9c6f0f2","articles":"db25faa6","calendar":"2db04d5a","editPost":"ce72759f","errorModal":"af33cefc","login":"61bd44e3","loginChange":"f7468ba7","loginRegistration":"b8dc9138","loginRegistrationSuccess":"fbc6dbab","loginRestore":"11f05e9d","loginSignIn":"5945ff7f","mainPage":"c9d5ccfd","profile":"1445a260","settings":"7c2af028","stat":"ac1bf1f4","userSection":"847a5f80","addComment":"8407ff71","baseArticle":"d8032b02","comment":"7fb4fec6","baseButton":"3a7bae3c","baseNavbar":"bbaecea2","calendarTable":"25bd32c3","loginHeader":"c7e33100","captcha":"66dda667","inputPassword":"638924f7","inputEmail":"25efc46a","tags":"cc637194","addText":"3b2c4c96","moderationBlock":"b68add48","socialBlock":"b5601ec6","calendarMonth":"dd972471"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"404":1,"article":1,"articles":1,"calendar":1,"editPost":1,"errorModal":1,"login":1,"loginRegistrationSuccess":1,"mainPage":1,"profile":1,"settings":1,"stat":1,"userSection":1,"addComment":1,"baseArticle":1,"comment":1,"baseButton":1,"baseNavbar":1,"calendarTable":1,"loginHeader":1,"tags":1,"addText":1,"moderationBlock":1,"socialBlock":1,"calendarMonth":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"404":"404","article":"article","articles":"articles","calendar":"calendar","editPost":"editPost","errorModal":"errorModal","login":"login","loginChange":"loginChange","loginRegistration":"loginRegistration","loginRegistrationSuccess":"loginRegistrationSuccess","loginRestore":"loginRestore","loginSignIn":"loginSignIn","mainPage":"mainPage","profile":"profile","settings":"settings","stat":"stat","userSection":"userSection","addComment":"addComment","baseArticle":"baseArticle","comment":"comment","baseButton":"baseButton","baseNavbar":"baseNavbar","calendarTable":"calendarTable","loginHeader":"loginHeader","captcha":"captcha","inputPassword":"inputPassword","inputEmail":"inputEmail","tags":"tags","addText":"addText","moderationBlock":"moderationBlock","socialBlock":"socialBlock","calendarMonth":"calendarMonth"}[chunkId]||chunkId) + "." + {"404":"0307462e","article":"d31131f7","articles":"ab6c5fed","calendar":"7ef4a90f","editPost":"c8f88f38","errorModal":"fbaa6531","login":"6bc2a293","loginChange":"31d6cfe0","loginRegistration":"31d6cfe0","loginRegistrationSuccess":"a879d2f2","loginRestore":"31d6cfe0","loginSignIn":"31d6cfe0","mainPage":"4f8b7404","profile":"9d56705d","settings":"fa684121","stat":"02b1e9f5","userSection":"c1ee68c4","addComment":"3bd0147c","baseArticle":"4b2c7168","comment":"2e97f697","baseButton":"f7cd099c","baseNavbar":"0c5366b4","calendarTable":"dc9a89bb","loginHeader":"5b0e4dcc","captcha":"31d6cfe0","inputPassword":"31d6cfe0","inputEmail":"31d6cfe0","tags":"95166178","addText":"3e32e758","moderationBlock":"0feff8c7","socialBlock":"b00d958f","calendarMonth":"c4c06180"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
